import React from 'react'
import PropTypes from 'prop-types'
import { Select } from '../Select/Select'
import update from 'react-addons-update'
import {polyglot} from '../../../index'

class MultipleInnerInputs extends React.Component {
  constructor (props) {
    super(props)
    this.state = {
      labelSize: props.expandInputArea ? 3 : 6,
    }
    this.renderInputs = this.renderInputs.bind(this)
    this.handleChange = this.handleChange.bind(this)
  }
  componentWillMount () {
    if (this.props.savedData) {
      this.props.fields.forEach(function (element) {
        if (this.props.savedData) {
          if (typeof (this.props.savedData) === 'object') {
            this.setState({
              [element.name]: this.props.savedData[element.name] || null
            })
          } else {
            this.setState({
              [element.name]: this.props.savedData || null
            })
          }
        }
      }.bind(this))
    }
  }

  handleChange (name, value, parentName) {
    const updated = update(this.state, {[name]: {$set: value}})
    if (value) {
      this.setState({
        [name]: value
      }, () => {
        this.props.getFieldValue(parentName, updated)
      })
    }
  }

  renderInputs () {
    let size = Math.floor((12 - this.state.labelSize) / this.props.fields.length)
    if (size < 1) {
      size = 1
    }
    return this.props.fields.map(function (element, index) {
      if (!element.hasOwnProperty('required')) {
        element['required'] = false
      }
      if (!element.hasOwnProperty('readOnly')) {
        element['readOnly'] = false
      }
      if (element.type === 'select') {
        return <div key={index}>
          <div className={`col-sm-${size}`}>
            <Select addon={element.addon}
              required={element.required}
              savedData={this.props.savedData && this.props.savedData[element.name]}
              parentName={this.props.name}
              getFieldValue={this.handleChange}
              name={element.name}
              options={element.options} />
          </div>
        </div>
      }
    }.bind(this))
  }

  render () {
    return <div className='form-group'>
      <label className={`col-xs-12 col-sm-${this.state.labelSize} control-label`}>{polyglot.t(this.props.label)}</label>
      {this.renderInputs()}
    </div>
  }
}

MultipleInnerInputs.propTypes = {
  name: PropTypes.string.isRequired,
  fields: PropTypes.arrayOf(PropTypes.shape({required: PropTypes.bool, name: PropTypes.string.isRequired, placeholder: PropTypes.string, type: PropTypes.string.isRequired})).isRequired,
  label: PropTypes.string.isRequired,
  getFieldValue: PropTypes.func.isRequired,
  savedData: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
  expandInputArea: PropTypes.bool
}

export {MultipleInnerInputs}

// TODO add other inputs



// WEBPACK FOOTER //
// ./src/components/common/MultipleInnerInputs/MultipleInnerInputs.js